const modalEditorLayout = () => import(/* webpackChunkName: "rich-editor" */ '../../core/gd-components/editor/plugins/layout/modal/modal-editor-layout')
const modalEditorTableSize = () => import(/* webpackChunkName: "rich-editor" */ '../../core/gd-components/editor/plugins/layout/modal/modal-editor-table-size')

export default class RichEditorModalsManager {

    constructor() {}

    columnsLayout(callback) {
        gd.modal.loadAndShow(modalEditorLayout, false, {
            className   : 'modal-editor-layout',
            modalType   : 'v4',
            params      : {
                onSubmit: (result) => {
                    gd.modal.hide()
                    callback && callback(result)
                },
            }
        })
    }

    tableSize(callback) {
        gd.modal.loadAndShow(modalEditorTableSize, false, {
            className   : 'modal-editor-table-size',
            modalType   : 'v4',
            params      : {
                onSubmit: (result) => {
                    gd.modal.hide()
                    callback && callback(result)
                },
            }
        })
    }
}
